import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    DamageStatus,
} from 'app/enums/label.enums'
import {
    Damage,
} from './Damages.types'

const config: SkyNetTableConfig<keyof Damage> = {
    name: 'Damages',
    tabs: [{
        name: 'All Damages',
        url: 'all',
        fields: [
            {
                name: 'damageNumber',
                labelKey: 'Damages.damageNumber',
                reduced: true,
            },
            {
                name: 'serialNumber',
                labelKey: 'Damages.serialNumber',
                reduced: true,
            },
            {
                name: 'containerModel',
                labelKey: 'Damages.containerModel',
                filterField: 'containerModel',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'reportedOn',
                labelKey: 'Damages.reportedOn',
                componentName: 'DateTimeCell',
            },
            {
                name: 'causingOrder',
                labelKey: 'Damages.causingOrder',
                filterField: 'causingOrder',
                filterType: FilterType.Array,
            },
            {
                name: 'linkedPriorDamageNumber',
                labelKey: 'Damages.linkedPriorDamage',
                filterField: 'linkedPriorDamageNumber',
                filterType: FilterType.Array,
            },
            {
                name: 'damageTypeName',
                filterField: 'damageTypeName',
                filterType: FilterType.Array,
                labelKey: 'Damages.damageType',
            },
            {
                name: 'damageStatus',
                labelKey: 'Damages.damageStatus',
                filterField: 'damageStatus',
                filterType: FilterType.Array,
                allowedValuesEnum: DamageStatus,
                componentName: 'EnumValue',
            },
            {
                name: 'repairingServiceCenter',
                labelKey: 'Damages.repairingServiceCenter',
                filterField: 'repairingServiceCenter',
                filterType: FilterType.Array,
            },
            {
                name: 'repairedOn',
                labelKey: 'Damages.repairedOn',
                componentName: 'DateTimeCell',
            },
            {
                name: 'repairedBy',
                labelKey: 'Damages.repairedBy',
                filterField: 'repairedBy',
                filterType: FilterType.Array,
            },
        ],
    }],
}

export default config
